<template>
  <form @submit.prevent="saveSurvey">
    <div v-if="surveyLoading" class="flex justify-center">Loading...</div>
    <div v-else>
      <h2>Create a New Survey</h2>
      <div class="col-12">
        <div class="card">

          <h5>Title</h5>
          <div class="grid p-fluid formgrid">
            <div class="col-12 mb-2 field">
              <InputText type="text" placeholder="Default" v-model="model.title"></InputText>
            </div>
          </div>
          <h5>Description</h5>
          <div class="grid p-fluid formgrid">
            <div class="col-12 mb-2 field">
              <Textarea type="text" placeholder="Default" v-model="model.description"></Textarea>
            </div>
          </div>



            <h3 class="text-2xl font-semibold flex items-center justify-between">
              Questions
              <Button icon="pi pi-plus" label="Add" class="p-button-success ml-2" @click="addQuestion()" />


              <!--/ Add new question -->
            </h3>
            <div v-if="!model.questions.length" class="text-center text-gray-600">
              You don't have any questions created
            </div>
            <div v-for="(question, index) in model.questions" :key="question.id">
              <QuestionEditor
                  :question="question"
                  :index="index"
                  @change="questionChange"
                  @addQuestion="addQuestion"
                  @deleteQuestion="deleteQuestion"
              />
            </div>
          <div class="p-d-flex p-jc-end p-mt-3">
            <Button type="submit" label="Create Survey" icon="pi pi-check"/>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script setup>
import {v4 as uuidv4} from "uuid";
import {computed, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import store from "../store";
import QuestionEditor from "../components/QuestionEditorNew.vue";


const router = useRouter();

const route = useRoute();

// Get survey loading state, which only changes when we fetch survey from backend
const surveyLoading = computed(() => store.state.currentSurvey.loading);

// Create empty survey
let model = ref({
  title: "",
  slug: "",
  status: false,
  description: null,
  image: null,
  image_url: null,
  expire_date: null,
  questions: [],
});

// Watch to current survey data change and when this happens we update local model
watch(
    () => store.state.currentSurvey.data,
    (newVal) => {
      model.value = {
        ...JSON.parse(JSON.stringify(newVal)),
        status: !!newVal.status,
      };
    }
);

// If the current component is rendered on survey update route we make a request to fetch survey
if (route.params.id) {
  store.dispatch("getSurvey", route.params.id);
}


function addQuestion(index) {
  const newQuestion = {
    id: uuidv4(),
    type: "text",
    question: "",
    description: null,
    data: {},
  };

  model.value.questions.splice(index, 0, newQuestion);
}

function deleteQuestion(question) {
  model.value.questions = model.value.questions.filter((q) => q !== question);
}

function questionChange(question) {
  // Important to explicitelly assign question.data.options, because otherwise it is a Proxy object
  // and it is lost in JSON.stringify()
  if (question.data.options) {
    question.data.options = [...question.data.options];
  }
  model.value.questions = model.value.questions.map((q) => {
    if (q.id === question.id) {
      return JSON.parse(JSON.stringify(question));
    }
    return q;
  });
}

/**
 * Create or update survey
 */
function saveSurvey() {
  let action = "created";
  if (model.value.id) {
    action = "updated";
  }
  store.dispatch("saveSurvey", {...model.value}).then(({data}) => {
    store.commit("notify", {
      type: "success",
      message: "The survey was successfully " + action,
    });
    router.push({
      name: "SurveyView",
      params: {id: data.data.id},
    });
  });
}

</script>

<style></style>
